import { faTimes, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Link, useLocation } from "react-router-dom";
import small from "../../src/assets/images/logo-small.png";

const MobileMenuOverlay = ({ isOpen, onClose, menus }) => {
  const [openSubmenus, setOpenSubmenus] = useState({});
  const location = useLocation();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const toggleSubmenu = (index) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleLinkClick = () => {
    onClose();
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  const renderMenuItem = (item, index) => {
    const hasSubmenu = item.sub_menu && item.sub_menu.length > 0;
    const isSubOpen = openSubmenus[index];

    return (
      <div key={index} style={styles.menuItemContainer}>
        <div style={styles.menuItemRow}>
          {item.type === "url" ? (
             <a
              href={item.external_url}
              target="_blank"
              rel="noreferrer"
              style={styles.menuLink}
              onClick={handleLinkClick}
            >
              {item.name}
            </a>
          ) : (
            <Link
              to={item.slug === "/" ? "/" : `/${item.slug}`}
              style={{
                  ...styles.menuLink,
                  color: location.pathname === (item.slug === "/" ? "/" : `/${item.slug}`) ? "#fff" : "#111", // Active White, Default Dark
                  textDecoration: location.pathname === (item.slug === "/" ? "/" : `/${item.slug}`) ? "underline" : "none"
              }}
              onClick={() => {
                  if (!hasSubmenu) handleLinkClick();
                  else toggleSubmenu(index);
              }}
            >
              {item.name}
            </Link>
          )}

          {hasSubmenu && (
            <div
              onClick={(e) => {
                 e.stopPropagation();
                 toggleSubmenu(index);
              }}
              style={styles.chevronContainer}
            >
               <span style={{ 
                   transform: isSubOpen ? 'rotate(180deg)' : 'rotate(0deg)', 
                   transition: 'transform 0.3s',
                   display: 'inline-block'
               }}>
                 <FontAwesomeIcon icon={faChevronDown} />
               </span>
            </div>
          )}
        </div>

        {hasSubmenu && (
          <div 
            style={{
              ...styles.submenuContainer,
              maxHeight: isSubOpen ? "1000px" : "0",
              opacity: isSubOpen ? 1 : 0,
              paddingBottom: isSubOpen ? "5px" : "0",
              transition: "all 0.3s ease-in-out",
              overflow: "hidden"
            }}
          >
            {item.sub_menu.map((subItem, subIndex) => (
              <div key={subIndex} style={styles.subMenuItem}>
                 {subItem.type === "url" ? (
                    <a href={subItem.external_url} target="_blank" rel="noreferrer" style={styles.subMenuLink} onClick={handleLinkClick}>
                        {subItem.name}
                    </a>
                 ) : (
                    <Link 
                        to={`/${subItem.slug}`} 
                        style={{
                            ...styles.subMenuLink,
                            color: location.pathname === `/${subItem.slug}` ? "#fff" : "#111",
                            fontWeight: location.pathname === `/${subItem.slug}` ? "700" : "500",
                            textDecoration: location.pathname === `/${subItem.slug}` ? "underline" : "none"
                        }}
                        onClick={handleLinkClick}>
                        {subItem.name}
                    </Link>
                 )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  return createPortal(
    <div style={{...styles.overlay, animation: "mobileMenuSlideIn 0.3s ease-out"}}>
      <div style={styles.header}>
        <div style={styles.logoContainer}>
            <img src={small} alt="Logo" style={styles.logo} />
        </div>
        <button onClick={onClose} style={styles.closeButton}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>

      <div style={styles.content}>
        {menus && menus.map((item, index) => {
             if (item.name !== "FAQ" && item.id !== 14) {
                 return renderMenuItem(item, index);
             }
             return null;
        })}
      </div>
    </div>,
    document.body
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "#FDCB45",
    zIndex: 999999,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    fontFamily: '"Open Sans", sans-serif',
    animation: "fadeIn 0.2s ease-out",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 15px",
    borderBottom: "1px solid rgba(0,0,0,0.1)",
    backgroundColor: "#252525",
    position: "sticky",
    top: 0,
    zIndex: 10,
  },
  logo: {
      height: "auto",
      display: "block",
      marginLeft: "15px",
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "28px",
    cursor: "pointer",
    padding: "10px",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "25px",
  },
  content: {
    padding: "10px 0",
    display: "flex",
    flexDirection: "column",
  },
  menuItemRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "15px 25px",
  },
  menuLink: {
    textDecoration: "none",
    color: "#111",
    fontSize: "18px",
    fontWeight: "600",
    flex: 1,
  },
  chevronContainer: {
    padding: "10px",
    cursor: "pointer",
    color: "#111",
  },
  submenuContainer: {
    backgroundColor: "rgba(0,0,0,0.05)",
    paddingBottom: "5px",
  },
  subMenuItem: {
    padding: "15px 25px 15px 40px",
  },
  subMenuLink: {
    textDecoration: "none",
    color: "#111",
    fontSize: "18px",
    fontWeight: "500",
    display: "block",
  },
};

export default MobileMenuOverlay;
